import { createFileRoute, redirect } from '@tanstack/react-router'
import SettingsShellPage from '@/pages/settings/shell'
import AiIntegrationsSettingsPage from '@/pages/settings/ai-integrations'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'

function SettingsAiIntegrationsRoutePage() {
  return (
    <SettingsShellPage activeTab="ai-integrations">
      <AiIntegrationsSettingsPage />
    </SettingsShellPage>
  )
}

export const Route = createFileRoute('/$lang/settings/ai-integrations')({
  beforeLoad: ({ context, params, location }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      throw redirect({
        to: '/$lang/settings/general',
        params: { lang: params.lang },
        replace: true,
      })
    }
    requireAuthenticated(context, params, location.href)
  },
  staticData: { layout: 'main' },
  component: SettingsAiIntegrationsRoutePage,
})
